import { Action } from '@ngrx/store';

export enum ModifyReasonActionTypes {
  SET_MODIFY_REASON_CODE = '[Modify Reason] Set modify reason code',
  SET_MODIFY_REASON_COMMENT = '[Modify Reason] Set modify reason comment',
  RESET_MODIFY_REASON = '[Modify Reason] Reset',
}

export class SetModifyReasonCodeAction implements Action {
  readonly type = ModifyReasonActionTypes.SET_MODIFY_REASON_CODE;

  constructor(public payload: number) {}
}

export class SetModifyReasonCommentAction implements Action {
  readonly type = ModifyReasonActionTypes.SET_MODIFY_REASON_COMMENT;

  constructor(public payload: string) {}
}

export class ModifyReasonResetAction implements Action {
  readonly type = ModifyReasonActionTypes.RESET_MODIFY_REASON;

  constructor() {}
}

export type ModifyReasonActions = SetModifyReasonCodeAction | SetModifyReasonCommentAction | ModifyReasonResetAction;
